import { flagPropTypes, namespace } from '../../model';
import { Line } from '../line/line';
import classnames from 'classnames';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import IconFactory from '../../../icons/factory-builder';

const namecolorspace = 'ui-pdp-background-color';

export const Flag = ({
  tooltipNamespace = '',
  valueClassName = '',
  lineClassName = '',
  tooltipPosition = null,
  tooltipValue = null,
  icon = null,
  poleSize = '',
}) => (
  <div className={tooltipNamespace} style={{ left: tooltipPosition.position }}>
    <div
      className={classnames(valueClassName, `${namecolorspace}--${tooltipValue.bg_color}`)}
      style={{ left: tooltipPosition.valuePosition }}
    >
      <StyledLabel {...tooltipValue} />
      {icon && IconFactory(icon)}
    </div>
    <Line
      className={classnames(
        lineClassName,
        `${namecolorspace}--${tooltipValue.bg_color}`,
        `${namespace}__pole-size--${poleSize}`,
      )}
    />
  </div>
);

Flag.propTypes = flagPropTypes;
